import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';

@Injectable({
  providedIn: 'root'
})
export class PdfFormFillService {
  
  async fillAndSave(pdfDoc: PDFDocument, values: Record<string, string | boolean>): Promise<Uint8Array> {
    const form = pdfDoc.getForm();
    const fields = form.getFields();

    for (const field of fields) {
      const name = field.getName();
      if (values[name] !== undefined) {
        const val = values[name];
        
        try {
          if (field.constructor.name === 'PDFCheckBox') {
            if (val === true || val === 'true') {
              (field as any).check();
            } else {
              (field as any).uncheck();
            }
          } else {
            // Text fields
            (field as any).setText(val ? String(val) : '');
          }
        } catch (e) {
          console.warn(`Could not set value for field ${name}:`, e);
        }
      }
    }

    return await pdfDoc.save();
  }
}
